import React, { createContext, useContext, useState, useEffect } from "react";
import axiosInstance from "../Config/axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Loader from "../Components/Loader/Loader";

const PreferencesContext = createContext();
export const usePreferences = () => useContext(PreferencesContext);

export const PreferencesProvider = ({ children }) => {
  const [user, setUser] = useState(() => JSON.parse(localStorage.getItem("user")) || null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

 const fetchSports = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get("/adminpanel/metadata/?type=sports&company_id=1");
      return response.data.sports;
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Failed",
        text: `Failed to fetch sports!`,
        confirmButtonColor: "#B79527", // orange / gold
      cancelButtonColor: "#1C1C1C",
      });
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const addPreferedSports = async (payload) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("/customer/parent/preferences/", payload);
      if(response.data){
        Swal.fire({
          icon: "success",
          title: "Success",
          text: `Preferences Added Successfully!`,
          confirmButtonColor: "#B79527", // orange / gold
      cancelButtonColor: "#1C1C1C",
        });
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Failed",
        text: `Failed to add Preferences!`,
        confirmButtonColor: "#B79527", // orange / gold
      cancelButtonColor: "#1C1C1C",
      });
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };


  const fetchPreferedSports = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get("/customer/parent/preferences/");
      
      const userStr = localStorage.getItem('user');
      if (userStr) {
          const user = JSON.parse(userStr);
          user.has_preferences = response.data?.has_preferences;
          localStorage.setItem('user', JSON.stringify(user));
      }
      return response.data?.preferred_sports;
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Failed",
        text: `Failed to fetch Preferences!`,
        confirmButtonColor: "#B79527", // orange / gold
      cancelButtonColor: "#1C1C1C",
      });
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  

  
  
  return (
    <PreferencesContext.Provider value={{ fetchSports, addPreferedSports, fetchPreferedSports}}>
      {loading && (
       <Loader/>
      )}
      {children}
    </PreferencesContext.Provider>
  );
};
